var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import { useTypedSelector } from "../state/store";
import * as quizAnswerActions from "../state/quizAnswer/actions";
import { StyledTextField } from "./styleComponents";
import { ItemContent, SpaciousPaper } from "./styleComponents";
import LaterQuizItemAddition from "./LaterQuizItemAddition";
import MarkdownText from "./MarkdownText";
import ThemeProviderContext from "../contexes/themeProviderContext";
var SolutionPaper = styled(SpaciousPaper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-left: 1rem solid ", ";\n\n  p {\n    margin: 0;\n  }\n"], ["\n  border-left: 1rem solid ", ";\n\n  p {\n    margin: 0;\n  }\n"])), function (props) {
  return props.correct ? "#047500" : "#DB0000";
});
var Open = function Open(_a) {
  var item = _a.item;
  var themeProvider = React.useContext(ThemeProviderContext);
  var dispatch = useDispatch();
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var answer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var displayFeedback = useTypedSelector(function (state) {
    return state.feedbackDisplayed;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  if (!languageInfo) {
    return React.createElement("div", null);
  }
  var handleTextDataChange = function handleTextDataChange(e) {
    dispatch(quizAnswerActions.changeTextData(item.id, e.currentTarget.value));
  };
  var itemAnswer = answer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  if (!itemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }
  var correct = itemAnswer ? itemAnswer.correct : false;
  var textData = itemAnswer ? itemAnswer.textData : "";
  var openLabels = languageInfo.open;
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var itemTitle = item.title;
  var successMessage = item.successMessage,
    failureMessage = item.failureMessage;
  var singleItemQuiz = quiz && quiz.items.length === 1;
  var providedStyles = singleItemQuiz ? themeProvider.narrowOpenItemContentStyles : themeProvider.wideOpenItemContentStyles;
  var guidance = React.createElement(React.Fragment, null, React.createElement(MarkdownText, {
    id: itemTitle + "-title",
    variant: "h6",
    variantMapping: {
      h6: "p"
    }
  }, itemTitle), React.createElement(MarkdownText, {
    variant: "body1"
  }, item.body));
  var FeedbackMessage = themeProvider.feedbackMessage || SolutionPaper;
  if (displayFeedback) {
    var answerPortion = answerLocked ? React.createElement(SpaciousPaper, null, React.createElement(Typography, {
      variant: "body1"
    }, textData)) : React.createElement(StyledTextField, {
      rowNumber: item.order,
      value: textData,
      onChange: handleTextDataChange,
      fullWidth: true,
      margin: "normal",
      variant: "outlined",
      label: openLabels.placeholder,
      id: itemTitle + "-textfield"
    });
    return React.createElement(ItemContent, {
      providedStyles: providedStyles
    }, React.createElement("div", {
      className: "openAnswered"
    }, guidance, React.createElement(Typography, {
      component: "p",
      variant: "subtitle1"
    }, openLabels.userAnswerLabel, ":"), answerPortion, React.createElement(FeedbackMessage, {
      correct: correct,
      message: correct ? openLabels.feedbackForSuccess : openLabels.feedbackForFailure
    }, React.createElement(MarkdownText, {
      Component: Typography,
      variant: "body1"
    }, correct ? successMessage || openLabels.feedbackForSuccess : failureMessage || openLabels.feedbackForFailure))));
  }
  return React.createElement(ItemContent, {
    providedStyles: providedStyles
  }, React.createElement("div", {
    className: "open"
  }, guidance, React.createElement(StyledTextField, {
    rowNumber: item.order,
    value: textData,
    onChange: handleTextDataChange,
    fullWidth: true,
    margin: "normal",
    variant: "outlined",
    label: openLabels.placeholder,
    disabled: quizDisabled,
    id: itemTitle + "-textfield"
  })));
};
export default Open;
var templateObject_1;